import { OrganizationTable } from './OrganizationTable';
export default OrganizationTable;
